const defaultValues = (fields) => {
    const form = {};
    fields.forEach((field) => {
        const type = field.type.toLowerCase();
        if (type === 'multiselect') {
            form[`input_${field.id}`] = [];
        }
        else {
            form[`input_${field.id}`] = '';
        }
    });
    return form;
};
export default defaultValues;
